(() => {
    var window_width = null;
    let tabsContainerMobile = document.getElementsByClassName('tabs-container-mob');
    let tabsContainerDesktop = document.getElementsByClassName('tabs-container-desk');
    let tabsMobile = tabsContainerMobile[0].getElementsByClassName('tab-item');
    let tabsDesktop = tabsContainerDesktop[0].getElementsByClassName('tab-item');

    let location = window.location.href;
    let body = '';
    let bodyDataBrand = '';
    let bodyDataBrandSearch = '';

    function getLogoTabPosition() {
        return new Promise((resolve) => {
            body = document.getElementsByTagName('body');
            bodyDataBrand = body[0].getAttribute('data-brand');
            bodyDataBrandSearch = body[0].getAttribute('data-brand-search');
            let tab1 = '';
            let tab2 = '';

            if (bodyDataBrand == 'index' || bodyDataBrand == 'acento' || bodyDataBrand == 'general' || bodyDataBrand == 'acento-casa') {
                if (window_width <= 1149) {
                    tab1 = tabsMobile[0].getBoundingClientRect();
                    tab2 = tabsMobile[1].getBoundingClientRect();

                    const distanceToRightEdge = window.innerWidth - tab1.right;
                    const distanceTab1ToLeftEdge = tab1.left;

                    tabsContainerMobile[0].style.setProperty('--tab-line-acento-before-width', `${distanceTab1ToLeftEdge + 2.5}px`);
                    tabsContainerMobile[0].style.setProperty('--tab-line-acento-before-left', `${(tab1.left + 2.5) * -1}px`);

                    tabsContainerMobile[0].style.setProperty('--tab-line-acento-after-width', `${distanceToRightEdge + 2.5}px`);
                    tabsContainerMobile[0].style.setProperty('--tab-line-acento-after-right', `${tab1.width - 2.5}px`);

                    resolve();

                } else {
                    tab1 = tabsDesktop[0].getBoundingClientRect();
                    tab2 = tabsDesktop[1].getBoundingClientRect();

                    const distanceToRightEdge = window.innerWidth - tab1.right;
                    const distanceTab1ToLeftEdge = tab1.left;

                    tabsContainerDesktop[0].style.setProperty('--tab-line-acento-before-width', `${distanceTab1ToLeftEdge + 2.5}px`);
                    tabsContainerDesktop[0].style.setProperty('--tab-line-acento-before-left', `${(tab1.left + 2.5) * -1}px`);

                    tabsContainerDesktop[0].style.setProperty('--tab-line-acento-after-width', `${distanceToRightEdge + 2.5}px`);

                    if (bodyDataBrandSearch == 'acento-casa') {
                        setTimeout(() => {
                            tab1 = tabsDesktop[0].getBoundingClientRect();
                            tabsContainerDesktop[0].style.setProperty('--tab-line-acento-after-right', `${tab1.width - 2.5}px`);
                        }, 500);
                    } else {
                        tabsContainerDesktop[0].style.setProperty('--tab-line-acento-after-right', `${tab1.width - 2.5}px`);
                    }

                    resolve();
                }

            } else if (bodyDataBrand == 'decor-living') {
                if (window_width <= 1149) {
                    tab1 = tabsMobile[1].getBoundingClientRect();
                    tab2 = tabsMobile[0].getBoundingClientRect();

                    const distanceToRightEdge = window.innerWidth - tab1.right;
                    const distanceTab1ToLeftEdge = tab1.left;

                    tabsContainerMobile[0].style.setProperty('--tab-line-decor-before-left', `${(distanceTab1ToLeftEdge + 2.5) * -1}px`);
                    tabsContainerMobile[0].style.setProperty('--tab-line-decor-before-width', `${tab1.left + 2.5}px`);

                    tabsContainerMobile[0].style.setProperty('--tab-line-decor-after-width', `${distanceToRightEdge + 2.5}px`);

                    resolve();

                } else {
                    tab1 = tabsDesktop[1].getBoundingClientRect();
                    tab2 = tabsDesktop[0].getBoundingClientRect();

                    const distanceToRightEdge = window.innerWidth - tab1.right;
                    const distanceTab1ToLeftEdge = tab1.left;

                    tabsContainerDesktop[0].style.setProperty('--tab-line-decor-before-left', `${(distanceTab1ToLeftEdge + 2.5) * -1}px`);
                    tabsContainerDesktop[0].style.setProperty('--tab-line-decor-before-width', `${tab1.left + 2.5}px`);

                    tabsContainerDesktop[0].style.setProperty('--tab-line-decor-after-width', `${distanceToRightEdge + 2.5}px`);

                    resolve();
                }

            } else {
                if (window_width <= 1149) {
                    tab1 = tabsMobile[0].getBoundingClientRect();
                    tab2 = tabsMobile[1].getBoundingClientRect();

                    const distanceToRightEdge = window.innerWidth - tab1.right;
                    const distanceTab1ToLeftEdge = tab1.left;

                    tabsContainerMobile[0].style.setProperty('--tab-line-acento-before-width', `${distanceTab1ToLeftEdge + 2.5}px`);
                    tabsContainerMobile[0].style.setProperty('--tab-line-acento-before-left', `${(tab1.left + 2.5) * -1}px`);

                    tabsContainerMobile[0].style.setProperty('--tab-line-acento-after-width', `${distanceToRightEdge + 2.5}px`);
                    tabsContainerMobile[0].style.setProperty('--tab-line-acento-after-right', `${tab1.width - 2.5}px`);

                    resolve();

                } else {
                    tab1 = tabsDesktop[0].getBoundingClientRect();
                    tab2 = tabsDesktop[1].getBoundingClientRect();

                    const distanceToRightEdge = window.innerWidth - tab1.right;
                    const distanceTab1ToLeftEdge = tab1.left;

                    tabsContainerDesktop[0].style.setProperty('--tab-line-acento-before-width', `${distanceTab1ToLeftEdge + 2.5}px`);
                    tabsContainerDesktop[0].style.setProperty('--tab-line-acento-before-left', `${(tab1.left + 2.5) * -1}px`);

                    tabsContainerDesktop[0].style.setProperty('--tab-line-acento-after-width', `${distanceToRightEdge + 2.5}px`);
                    tabsContainerDesktop[0].style.setProperty('--tab-line-acento-after-right', `${tab1.width - 2.5}px`);

                    resolve();
                }
            }
        });
    }

    function widthActual() {
        return window_width = window.innerWidth;
    }

    document.addEventListener("DOMContentLoaded", (ev) => {
        widthActual();
        getLogoTabPosition();
    });

    window.addEventListener("resize", (event) => {
        widthActual();

        getLogoTabPosition();
    });
})();
